import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";

function LicenseBlockedPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-200px)] px-4">
      <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg p-8">
        <div className="text-center">
          <ExclamationTriangleIcon className="h-20 w-20 text-red-600 mx-auto mb-6" />
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            {t("license.invalidTitle")}
          </h1>
          <p className="text-lg text-gray-600 mb-6">
            {t("license.featureBlocked")}
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mt-6">
          <h2 className="font-semibold text-blue-900 mb-4">
            {t("license.whatCanIDo")}
          </h2>

          <div className="space-y-3">
            {/* Manage License */}
            <div className="flex flex-row items-center justify-center gap-6 flex-wrap w-full">
              <button
                onClick={() => navigate("/servers")}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium transition-colors text-sm"
              >
                {t("license.goToLicenseManagement")}
              </button>
            
              <button
                onClick={() => navigate("/support")}
                className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-md font-medium transition-colors text-sm"
              >
                {t("license.goToSupport")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LicenseBlockedPage;
